var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 5.5,
    fill: "white",
    stroke: "#EAEAEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9993 26.6667C21.8605 26.6667 23.4368 26.0209 24.7285 24.7292C26.0202 23.4375 26.666 21.8612 26.666 20C26.666 18.1389 26.0202 16.5625 24.7285 15.2709C23.4368 13.9792 21.8605 13.3334 19.9993 13.3334C19.041 13.3334 18.1243 13.5312 17.2493 13.9267C16.3743 14.3223 15.6243 14.8884 14.9993 15.625V13.3334H13.3327V19.1667H19.166V17.5H15.666C16.1105 16.7223 16.7182 16.1112 17.4893 15.6667C18.2605 15.2223 19.0971 15 19.9993 15C21.3882 15 22.5688 15.4862 23.541 16.4584C24.5132 17.4306 24.9993 18.6112 24.9993 20C24.9993 21.3889 24.5132 22.5695 23.541 23.5417C22.5688 24.5139 21.3882 25 19.9993 25C18.9299 25 17.9646 24.6945 17.1035 24.0834C16.2424 23.4723 15.6382 22.6667 15.291 21.6667H13.541C13.9299 23.1389 14.7216 24.3403 15.916 25.2709C17.1105 26.2014 18.4716 26.6667 19.9993 26.6667Z",
    fill: "#5F6771"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.a1beb389f3babba9bd4773382827ac6d.svg";
export { ForwardRef as ReactComponent };